// @flow
import type { IdentifyType } from 'catena/er2_map_userlayers/js/reducers/identify'
import * as types from 'catena/er2_map_userlayers/js/constants/action_types'
import type { ExtentType } from 'catena/er2_map_userlayers/js/reducers/map'

export const onIdentifyHandled = () => ({ type: types.SET_IDENTIFY_HANDLED })
export const setIdentifyFeatures = (identifyState: IdentifyType) => ({ type: types.SET_IDENTIFY_FEATURES, identifyState })

export const onIdentify = (extent: ExtentType) => (dispatch: Function, getState: Function) => {
    const token = getState().token.value
    fetch(`/er2_map/api/v1/identify/?token=${token}`,
        {
            body: JSON.stringify({ extent }),
            method: 'POST',
        })
        .then(res => res.json())
        .then(res => dispatch(setIdentifyFeatures(res.state)))
        .catch(err => res => console.error(`Got failure to update mapfile ordering: ${res}`))
}
